var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "reject-form__popup" }, [
    _c("div", { staticClass: "reject-form__popup-title" }, [
      _vm._v(_vm._s(_vm.i18n.lbl_reject_message()))
    ]),
    _vm._v(" "),
    _c(
      "form",
      {
        staticClass: "reject-form__form",
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.submit.apply(null, arguments)
          }
        }
      },
      [
        _c("div", { staticClass: "reject-form__row" }, [
          _c(
            "div",
            { staticClass: "reject-form__field" },
            [
              _c("textarea-field", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: { name: "reject-message" },
                model: {
                  value: _vm.form.rejectReason,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "rejectReason", $$v)
                  },
                  expression: "form.rejectReason"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "reject-form__action-btn-wrapper" },
          [
            _c(
              "md-button",
              {
                staticClass: "md-primary",
                attrs: { disabled: _vm.isPending },
                on: { click: _vm.cancel }
              },
              [_vm._v(_vm._s(_vm.i18n.lbl_cancel()))]
            ),
            _vm._v(" "),
            _c(
              "md-button",
              {
                staticClass: "md-primary",
                attrs: { type: "submit", disabled: _vm.isPending }
              },
              [_vm._v(_vm._s(_vm.i18n.lbl_submit()))]
            )
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ded72a64", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ded72a64","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/contracts/index/modals/Contracts.RejectForm.vue
// module id = rMS/
// module chunks = 1